/* eslint-disable react-hooks/exhaustive-deps */
import React /*  { useEffect }  */ from "react";
import soldier from "../../../static/roman_soldier.png";
import sign from "../../../static/sign.png";
import check from "../../../static/check.png";
import "./custom.scss";

export default function CustomEnd({ history }) {
  /* useEffect(() => {
    setTimeout(() => {
      handleClickNewRegister();
    }, 30000);
  }, []); */

  const handleClickNewRegister = () => {
    history.push("/");
  };

  return (
    <div>
      <div
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          paddingTop: "2.65%",
          paddingLeft: "5%",
          backgroundImage: 'url("' + soldier + '")',
          height: "686px",
          width: "450px",
          backgroundSize: "cover",
        }}
      >
        {/*  <img alt="soldier" src={soldier} style={{}} /> */}
      </div>
      <div style={{ textAlign: "center", marginTop: "25px" }}>
        <img
          src={check}
          alt="check"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
      <div
        style={{ width: "34%", margin: "0 auto" }}
        className="custom-end-start-adventure"
      >
        Indulhat a kaland!
      </div>
      <p
        style={{ width: "34%", margin: "0 auto" }}
        className="custom-end-start-adventure-subtext"
      >
        A regisztrációd sikeres, kalandozásaid során ne feledd használni a
        kapott QR kódodat!
      </p>
      <div style={{ width: "34%", margin: "0 auto", textAlign: "center" }}>
        <button
          className="custom-new-register-button"
          onClick={handleClickNewRegister}
        >
          Új regisztráció{" "}
          <img
            src={sign}
            alt="sign"
            className="custom-new-register-button-logo"
          />
        </button>
      </div>
    </div>
  );
}
